var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Base from "../../Base.js";
import ObjectHelper from "../../helper/ObjectHelper.js";
var StoreState_default = (Target) => {
  var _a;
  return _a = class extends (Target || Base) {
    /**
     * Get store state. Used by State-plugin to serialize state
     * @private
     * @returns {{ sorters, groupers }}
     */
    getState() {
      const { sorters, groupers, filters } = this, state = {};
      if (sorters == null ? void 0 : sorters.length) {
        state.sorters = sorters.map((sorter) => {
          const clone = ObjectHelper.cleanupProperties(ObjectHelper.clone(sorter));
          delete clone.fn;
          delete clone.sortFn;
          return clone;
        });
      }
      if (groupers == null ? void 0 : groupers.length) {
        state.groupers = groupers.map((grouper) => {
          const clone = ObjectHelper.cleanupProperties(ObjectHelper.clone(grouper));
          delete clone.fn;
          return clone;
        });
        state.collapsedGroups = [...this.collapsedGroups];
      }
      if (filters == null ? void 0 : filters.values.length) {
        state.filters = filters.values.map((filter) => {
          const clone = ObjectHelper.cleanupProperties(ObjectHelper.clone(filter.config));
          clone.value = filter.value;
          if (clone.caseSensitive) {
            delete clone.caseSensitive;
          }
          return clone;
        });
      }
      return state;
    }
    /**
     * Apply store state. Used by State-plugin to restore a previously serialized state
     * @private
     * @param {{ sorters, groupers }} state
     */
    applyState(state) {
      var _a2;
      const me = this, {
        sorters = [],
        groupers = [],
        filters = []
      } = state, {
        sortParamName,
        filterParamName
      } = me;
      if (me.isSorted || sorters.length !== 0 || groupers.length !== 0) {
        me.sorters = sorters.filter((sorter) => sorter.field || sorter.sortFn && !sortParamName);
        me.groupers = groupers.slice();
        me.sort();
      }
      (_a2 = state.collapsedGroups) == null ? void 0 : _a2.forEach((id) => {
        const record = me.getById(id);
        if (record) {
          me.collapse(record, true);
        }
      });
      if (me.isFiltered || filters.length !== 0) {
        me.filters = filters.filter((filter) => filter.property || filter.filterBy && !filterParamName);
        me.filter();
      }
    }
  }, __publicField(_a, "$name", "StoreState"), _a;
};
export {
  StoreState_default as default
};
